<!-- eslint-disable -->
<template>
  <div :class="P_customClass" :style="C_buttonContainerStyle" >
    <component :is="DV_componentType">{{P_customCss}}</component>
    <button 
      v-show="C_isVisible"
      :style="C_buttonStyle" 
      :disabled="isTrue(P_disabled) || P_editing"
      @mousedown="eventMouseDown(P_buttonId, P_makeSingleEvent)"
      @mouseup="eventMouseRelease(P_buttonId, P_makeSingleEvent)"
      @click="eventMouseClick(P_buttonId, P_makeSingleEvent)"
      :class="{active: C_isActiveState}"
    >
      {{P_buttonText}}
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  name: "GButton",
  props: [
    'P_buttonText',
    'P_buttonWidth',
    'P_buttonHeight',
    'P_fontColor',
    'P_background',
    'P_fontSize',
    'P_borderColor',
    'P_padding',
    'P_buttonId',
    'P_makeSingleEvent',
    'P_customCss'
  ],
  mixins: [bi10GridComponent],
  data () {
    return {}
  },
  computed: {
    C_buttonContainerStyle() {
      const CI = this
      const additionalStyles = {}
      
      additionalStyles['height'] = CI.P_buttonHeight || "100%"
      additionalStyles['width'] = CI.P_buttonWidth || "100%"

      return additionalStyles;
    },
    C_buttonStyle () {
      const CI = this
      const customStyle = {
        width: CI.P_buttonWidth || '100%',
        height: CI.P_buttonHeight || '100%',
      }
      if (CI.P_fontSize) customStyle['fontSize'] = CI.P_fontSize
      if (CI.P_background) customStyle['background'] = CI.P_background
      if (CI.P_borderColor) customStyle['borderColor'] = CI.P_borderColor
      if (CI.P_fontColor) customStyle['color'] = CI.P_fontColor
      if (CI.P_padding) customStyle['padding'] = CI.P_padding
      
      return customStyle;
    }
  }
}
</script>

<style lang="less" scoped>
button {
  box-shadow: 0px 25px 12px #343333 inset;
  cursor: pointer;
  &:active {
    background: #93bac7 !important;
    box-shadow: none;
  }
  &.active{
    background: #93bac7 !important;
    box-shadow: none;
  }
  &:focus {
    outline: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/GButton.vue